// Turns plain-text URLs in Irene's replies into clickable links.
// Only http(s) URLs become links; everything else stays plain text (React escapes it).
import { createElement } from "react";

const URL_RE = /(https?:\/\/[^\s<>"')\]]+)/g;
const TRAILING_PUNCT = /[.,;:!?]+$/;

export function linkify(text) {
  if (typeof text !== "string" || !text.includes("http")) return text;

  const parts = text.split(URL_RE);
  return parts.flatMap((part, i) => {
    if (i % 2 === 0) return part ? [part] : []; // plain text between URLs
    const trailing = (part.match(TRAILING_PUNCT) || [""])[0];
    const url = trailing ? part.slice(0, -trailing.length) : part;
    return [
      createElement(
        "a",
        {
          key: `l${i}`,
          href: url,
          target: "_blank",
          rel: "noopener noreferrer",
          style: { color: "var(--accent)", textDecoration: "underline", textUnderlineOffset: "2px", wordBreak: "break-word" },
        },
        url
      ),
      trailing,
    ];
  });
}
